import * as CONST from "../const/action.const";
import * as UTILS from "../helpers/utils"
const initialState = {
  payments_list:  [],
  new_payment: null,
  invoice_statement: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.FIND_STUDENT_PAYMENT_SUCCESS:
      return {
        ...state,
        invoice_statement: payload
      };
    case CONST.FIND_STUDENT_PAYMENT_FAILURE:
      return {
        ...state,
        invoice_statement: null,
      };
    case CONST.CREATE_STUDENT_PAYMENT_SUCCESS:
      const pushToPaymentsListStudent = [...state.payments_list]
      pushToPaymentsListStudent.unshift(payload)
      return {
        ...state,
        invoice_statement: null,
        payments_list: pushToPaymentsListStudent
      };
    case CONST.CREATE_STUDENT_PAYMENT_FAILURE:
      return {
        ...state,
        invoice_statement: null,
      };
    case CONST.GET_STUDENT_PAYMENT_SUCCESS:
      return {
        ...state,
        invoice_statement: payload
      };
    case CONST.GET_STUDENT_PAYMENT_FAILURE:
      return {
        ...state,
        invoice_statement: null,
      };
    case CONST.UPDATE_STUDENT_PAYMENT_SUCCESS:
      console.log("state.payments_list",state.payments_list)
      let new_payments_list_st = [...state.payments_list]
      let index_st = UTILS.findObjectFromArrayWithId(state.payments_list, payload.id)
      new_payments_list_st[index_st] = payload
      console.log("new_payments_list",new_payments_list_st)
      return {
        ...state,
        payments_list: new_payments_list_st
      };
    case CONST.UPDATE_STUDENT_PAYMENT_FAILRUE:
      console.log("aaaaa33")
      return {
        ...state,
        payments_list: state.payments_list,
      };
    case CONST.GET_ALL_PAYMENTS_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        payments_list: payload
      };
    case CONST.DELETE_STUDENT_PAYMENT_SUCCESS:
      let new_payment_list = [...state.payments_list]
      new_payment_list = UTILS.removeObjectWithId(new_payment_list, payload.id)
      return {
        ...state,
        payments_list: new_payment_list,
      };
    case CONST.DELETE_STUDENT_PAYMENT_FAILURE:
      console.log("aaaaa33")
      return {
        ...state,
        payments_list: state.payments_list,
      };
    case CONST.GET_ALL_PAYMENTS_STUDENT_LIST_FAILURE:
      return {
        ...state,
        // payments_list: []
        payments_list: [
          {
            invoiceDate: "07/03/2022",
            invoiceNo: "123-45",
            invoiceDetails: {
              fromDate: "04/01/2022",
              toDate: "06/31/2022",
              modeOfPayment: "Dated Check",
              dueDate: "07/15/2022"
            },
            clientDetails: {
              name: "Hasan Radi",
              accountType: "Student",
              numberOfClass: 3,
              lastPayment: "03/25/2022"
            },
            tableData: [
              {
                courseCode: "1qw2",
                classTitle: "CLass A",
                totalSessions: 10.00,
                presentSessions: 8,
                absentSessions: 2,
                costOfSession: 20.00,
              },
              {
                courseCode: "2wq1",
                classTitle: "CLass B",
                totalSessions: 8.00,
                presentSessions: 8,
                absentSessions: 0,
                costOfSession: 15.00,
              },
              {
                courseCode: "2qw1",
                classTitle: "CLass C",
                totalSessions: 12.00,
                presentSessions: 11,
                absentSessions: 1,
                costOfSession: 25.00,
              }
            ],
            discount: 3,
            tax: 0,
            charges: 0
          },
           {
            invoiceDate: "07/03/2022",
            invoiceNo: "123-45",
            invoiceDetails: {
              fromDate: "04/01/2022",
              toDate: "06/31/2022",
              modeOfPayment: "Dated Check",
              dueDate: "07/15/2022"
            },
            clientDetails: {
              name: "Hasan Radi",
              accountType: "Student",
              numberOfClass: 3,
              lastPayment: "03/25/2022"
            },
            tableData: [
              {
                courseCode: "1qw2",
                classTitle: "CLass D",
                totalSessions: 10.00,
                presentSessions: 8,
                absentSessions: 2,
                costOfSession: 20.00,
              },
              {
                courseCode: "2wq1",
                classTitle: "CLass E",
                totalSessions: 8.00,
                presentSessions: 8,
                absentSessions: 0,
                costOfSession: 15.00,
              },
              {
                courseCode: "2qw1",
                classTitle: "CLass F",
                totalSessions: 12.00,
                presentSessions: 11,
                absentSessions: 1,
                costOfSession: 25.00,
              }
            ],
            discount: 3,
            tax: 0,
            charges: 0
          }
        ],
      };
    case CONST.GET_TEACHER_PAYMENT_SUCCESS:
      return {
        ...state,
        invoice_statement: payload
      };
    case CONST.GET_TEACHER_PAYMENT_FAILURE:
      return {
        ...state,
        invoice_statement: null,
      };
    case CONST.GET_ALL_PAYMENTS_TEACHER_LIST_SUCCESS:
      return {
        ...state,
        payments_list: payload
      };
    case CONST.GET_ALL_PAYMENTS_TEACHER_LIST_FAILURE:
      return {
        ...state,
        // payments_list: []
        payments_list: [
          {
            invoiceDate: "07/03/2022",
            invoiceNo: "123-45",
            invoiceDetails: {
              fromDate: "04/01/2022",
              toDate: "06/31/2022",
              modeOfPayment: "Dated Check",
            },
            clientDetails: {
              name: "Hasan Radi",
              accountType: "Student",
              numberOfClass: 3,
              lastPayment: "03/25/2022"
            },
            tableData: [
              {
                courseCode: "1qw2",
                classTitle: "CLass A",
                totalSessions: 10.00,
                presentSessions: 8,
                absentSessions: 2,
                costOfSession: 20.00,
              },
              {
                courseCode: "2wq1",
                classTitle: "CLass B",
                totalSessions: 8.00,
                presentSessions: 8,
                absentSessions: 0,
                costOfSession: 15.00,
              },
              {
                courseCode: "2qw1",
                classTitle: "CLass C",
                totalSessions: 12.00,
                presentSessions: 11,
                absentSessions: 1,
                costOfSession: 25.00,
              }
            ],
            discount: 3,
            tax: 0,
            charges: 0
          },
           {
            invoiceDate: "07/03/2022",
            invoiceNo: "123-45",
            invoiceDetails: {
              fromDate: "04/01/2022",
              toDate: "06/31/2022",
              modeOfPayment: "Dated Check",
              dueDate: "07/15/2022"
            },
            clientDetails: {
              name: "Hasan Radi",
              accountType: "Student",
              numberOfClass: 3,
              lastPayment: "03/25/2022"
            },
            tableData: [
              {
                courseCode: "1qw2",
                classTitle: "CLass D",
                totalSessions: 10.00,
                presentSessions: 8,
                absentSessions: 2,
                costOfSession: 20.00,
              },
              {
                courseCode: "2wq1",
                classTitle: "CLass E",
                totalSessions: 8.00,
                presentSessions: 8,
                absentSessions: 0,
                costOfSession: 15.00,
              },
              {
                courseCode: "2qw1",
                classTitle: "CLass F",
                totalSessions: 12.00,
                presentSessions: 11,
                absentSessions: 1,
                costOfSession: 25.00,
              }
            ],
            discount: 3,
            tax: 0,
            charges: 0
          }
        ],
      };
    case CONST.FIND_TEACHER_PAYMENT_SUCCESS:
      return {
        ...state,
        invoice_statement: payload
      };
    case CONST.FIND_TEACHER_PAYMENT_FAILURE:
      return {
        ...state,
        invoice_statement: null,
      };
    case CONST.CREATE_TEACHER_PAYMENT_SUCCESS:
      const pushToPaymentsListTeacher = [...state.payments_list]
      pushToPaymentsListTeacher.unshift(payload)
      return {
        ...state,
        invoice_statement: payload,
        payments_list: pushToPaymentsListTeacher
      };
    case CONST.CREATE_TEACHER_PAYMENT_FAILURE:
      return {
        ...state,
        invoice_statement: null,
      };
    case CONST.UPDATE_TEACHER_PAYMENT_SUCCESS:
      console.log("state.payments_list",state.payments_list)
      let new_payments_list_te = [...state.payments_list]
      let index_te = UTILS.findObjectFromArrayWithId(state.payments_list, payload.id)
      new_payments_list_te[index_te] = payload
      console.log("new_payments_list",new_payments_list_te)
      return {
        ...state,
        payments_list: new_payments_list_te
      };
    case CONST.UPDATE_TEACHER_PAYMENT_FAILRUE:
      console.log("aaaaa33")
      return {
        ...state,
        payments_list: state.payments_list,
      };
    case CONST.DELETE_TEACHER_PAYMENT_SUCCESS:
      return {
        ...state,
        payments_list: state.payments_list,
      };
    case CONST.DELETE_TEACHER_PAYMENT_FAILURE:
      console.log("aaaaa33")
      return {
        ...state,
        payments_list: state.payments_list,
      };
    default:
      return state;
  }
}
